<template>

    <main id="main" class="main-site">
        <div class="container">

            <Breadcrumb v-if="loadnew" :pages="breadcrumbPages" />

            <Loader class="col-md-12" v-if="!loadnew" />
            <div class="main-content-area">
                <div class="row" style="margin-bottom: 30px">
                    <div class="col-xs-12">
                        <div id="promotial-carousel" class="slide-carousel owl-carousel style-nav-1" data-items="1" data-loop="1" data-nav="true" data-autoplay="true" data-dots="false" data-slidespeed="1500" data-paginationSpeed="500">
                            <div class v-for="(item, index) in this.hotsite.slider" :key="index">
                                <a v-bind:href="item.staticLink">
                                    <img width="1170" height="281" v-bind:src="item.banner" v-bind:alt="item.alt" v-bind:title="item.title" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="wrap-product-detail">
                            <div class="advance-info no-margin">
                                <div class="tab-control normal">
                                    <a :class="['tab-control-item',  tabActive(index)  ]"
                                       v-for="(item, index) in this.hotsite.tabs"
                                       :key="index"
                                       v-bind:href="'#'+string_to_slug(item.titulo)">{{item.titulo}}</a>
                                </div>
                                <div class="tab-contents">
                                    <div :class="['tab-content-item', tabActive(index)  ]"
                                         v-for="(item, index) in this.hotsite.tabs"
                                         :key="index"
                                         v-bind:id="string_to_slug(item.titulo)">
                                        <div v-if="item.tipo == 1">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="description-category" v-if="item.ConteudoAba != null && item.tipo == 1">
                                                        <span v-html="descricao"></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <SimpleList v-if="loadnew" :list="hotsite.listModel1" :origem="tipo"></SimpleList>
                                        </div>
                                        <div v-else-if="item.tipo == 2 && item.filter == false">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="description-category" v-if="item.ConteudoAba != null && item.tipo == 2">
                                                        <span v-html="descricao"></span>

                                                    </div>
                                                </div>
                                            </div>
                                            <ul>
                                                <div class="row">
                                                    <div class="col-md-3"
                                                         v-for="(product, index) in hotsite.listModel2"
                                                         :key="index">
                                                        <Product v-if="loadnew" :product="product" />
                                                    </div>
                                                </div>
                                            </ul>
                                        </div>
                                        <div v-else-if="item.tipo == 2 && item.filter == true">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div v-if="item.ConteudoAba != null && item.tipo == 2" v-html="item.ConteudoAba"></div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <!-- <div class="col-md-3">
                                                Colocar Filtros: ainda não definido -->
                                                <!-- <product-filters :category="category" :brands="brands" :name="nome"></product-filters>
                                                </div> -->
                                                <div class="col-md-12">
                                                    <ul>
                                                        <div class="row">
                                                            <div class="col-md-3"
                                                                 v-for="(product, index) in hotsite.listModel2"
                                                                 :key="index">
                                                                <Product v-if="loadnew" :product="product" />
                                                            </div>
                                                        </div>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div v-if="item.ConteudoAba != null && (item.tipo != 1 && item.ConteudoAba != null)" v-html="item.ConteudoAba"></div> -->
                                        <div v-if="item.ConteudoAba != null && (item.titulo != 'Produtos')" v-html="item.ConteudoAba"></div>
                                        <div v-if="item.ConteudoAba == null && hotsite.conteudoEspecial != null && item.tipo == 3">
                                            <div class="row">
                                                <div class="col-md-3 text-center m20"
                                                     v-for="(item, index) in hotsite.conteudoEspecial"
                                                     :key="index">
                                                    <a href="#"><img v-bind:src="item.value" /></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="item.ConteudoAba == null && hotsite.marcas.length > 0 && item.tipo == 4">
                                            <div class="row">
                                                <div class="col-md-3 text-center m20"
                                                     v-for="(item, index) in hotsite.marcas"
                                                     :key="index">
                                                    <a :href="`${$SiteUrl}/loja/marcas/${string_to_slug(item.Nome)}`"><img v-bind:src="item.Logo" /></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="item.ConteudoAba == null && hotsite.campanhaMarcas.length > 0 && item.tipo == 4">
                                            <div class="row">
                                                <div class="col-md-3 text-center m20"
                                                     v-for="(item, index) in hotsite.campanhaMarcas"
                                                     :key="index">
                                                    <a :href="`${$SiteUrl}/loja/campanhas/${item.key}`"><img v-bind:src="item.value" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
    import axios from 'axios';
    const SimpleList = () => import('./partials/SimpleList.vue')
    const Breadcrumb = () => import('./partials/Breadcrumb.vue')
    const Product = () => import('./partials/Product.vue')
    const Loader = () => import('./partials/Loader.vue')


    export default {
        name: "CrazyHotSitePage",
        components: {
            SimpleList,
            Breadcrumb,
            Product,
            Loader,
        },
        metaInfo() {
            const route = this.$route;
            const _self = this;

            var url = 'https://www.aldo.com.br';
            url = `${url}${_self.$route.path.replace('/loja', '')}`;
            url = '0; url=' + url;

            if (localStorage.getItem('usuarioLogado') === null && localStorage.getItem('waitingLogin') === null) {
                return {
                    meta: [
                        { 'http-equiv': 'refresh', content: url }
                    ]
                }
            }
            else {
                return {
                    title: _self.title,
                    meta: [
                        { name: 'description', content: _self.metaDescription },
                        { name: 'twitter:card', content: _self.metaDescription },
                        { name: 'twitter:title', content: _self.title },
                        { name: 'twitter:description', content: _self.metaDescription },
                        // image must be an absolute path
                        { name: 'twitter:image', content: "https://www.aldo.com.br/assets/images/logo-top-1.png" },
                        // Facebook OpenGraph
                        { property: 'og:title', content: _self.title },
                        { property: 'og:site_name', content: 'Aldo Solar' },
                        { property: 'og:locale', content: 'pt_BR' },
                        { property: 'og:type', content: 'website' },
                        { property: 'og:image', content: "https://www.aldo.com.br/assets/images/logo-top-1.png" },
                        { property: 'og:description', content: _self.metaDescription }
                    ],
                    link: [
                        { rel: 'canonical', href: `${_self.$SiteUrl}${route.path.replace('/loja', '')}` }
                    ]
                }

            }

        },
        methods: {
            string_to_slug: function (value) {
                value = value.replace(/^\s+|\s+$/g, "");
                value = value.toLowerCase();

                var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
                var to = "aaaaaeeeeiiiioooouuuunc------";

                for (var i = 0, l = from.length; i < l; i++) {
                    value = value.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
                }

                value = value
                    .replace(/[^a-z0-9 -]/g, "")
                    .replace(/\s+/g, "-")
                    .replace(/-+/g, "-");

                return value;
            },
            tabActive: function (i) {
                return i == 0 ? "active" : "";
            },
            getCampanha: function () {
                const self = this;
                let urlCampanha = self.$route.params.id;
                let xhr = new XMLHttpRequest()
                xhr.open("GET", this.$apiUrl + "Marketing.svc/getcampanha/" + urlCampanha)
                xhr.setRequestHeader('Content-type', 'application/json')
                xhr.withCredentials = true
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        this.loading = false
                        let campanha = JSON.parse(xhr.responseText)
                        this.idCampanha = campanha.AbasCampanha[0].Id;
                        localStorage.idCampanha = this.idCampanha;
                        this.nome = campanha.AbasCampanha[0].Nome
                        this.title = campanha.AbasCampanha[0].MetaTitle
                            ? campanha.AbasCampanha[0].MetaTitle
                            : `${this.nome} - Seja Revendedor Aldo`
                        this.metaDescription = campanha.AbasCampanha[0].MetaDescription

                        // Carregando Banners
                        campanha.BannersRotativos.forEach((element) => {
                            let itemCarousel = {}
                            itemCarousel.banner = element.m_Item1
                            itemCarousel.staticLink = element.m_Item2 != '#' ? element.m_Item2 : '#'
                            itemCarousel.title = element.m_Item3;
                            itemCarousel.alt = element.m_Item4;
                            self.hotsite.slider.push(itemCarousel)
                        })

                        if (campanha.BannersRotativos.length > 0) {
                            setTimeout(function () { self.startSlider() }, 400);
                        }

                        // Carregando as Abas da Campanha
                        campanha.AbasCampanha.forEach((element) => {
                            if (element.ConteudoAba != null || element.Tipo === "P") {
                                let tab = {}

                                if (element.Tipo === "P" && campanha.Produtos.length == 0 && campanha.ListaProdutos.length == 0)
                                    return;

                                if (element.Tipo === "P") {
                                    tab.tipo = campanha.TipoListagem;
                                    tab.filter = false;
                                    if (campanha.AbasCampanha.find(element => element.AbaNome.toUpperCase() == 'SOBRE A CAMPANHA') != undefined) {
                                        tab.ConteudoAba = campanha.AbasCampanha.find(element => element.AbaNome.toUpperCase() == 'SOBRE A CAMPANHA').ConteudoAba;
                                        this.descricao = tab.ConteudoAba;
                                    }
                                }
                                else if (element.ConteudoAba != null) {
                                    tab.tipo = 3
                                    tab.ConteudoAba = element.ConteudoAba
                                }

                                tab.titulo = element.AbaNome

                                self.hotsite.tabs.push(tab)
                            }
                            else if (element.Tipo === "M" && campanha.Marcas.length > 0 && element.ConteudoAba == null) {
                                let tab = {}

                                tab.tipo = 4
                                tab.titulo = element.AbaNome
                                self.hotsite.marcas = campanha.Marcas
                                self.hotsite.tabs.push(tab)
                            }
                            else if (element.Tipo === "E" && element.ConteudoAba == null) {
                                let tab = {}

                                tab.tipo = 3
                                tab.titulo = element.AbaNome
                                self.hotsite.conteudoEspecial = campanha.ConteudoEspecial
                                self.hotsite.tabs.push(tab)
                            }
                            this.$delete(self.hotsite.tabs, self.hotsite.tabs.findIndex(element => element.titulo.toUpperCase() == 'SOBRE A CAMPANHA'));
                        })

                        if (campanha.TipoListagem == 2) {
                            campanha.ListaProdutos.forEach((element) => {
                                let product = {};

                                product.id = element.PRD_CODIGO;
                                product.code = element.PRD_CODIGO + "-" + element.PRD_CODIGODV;
                                product.name = element.PSG_DESCRICAO + " " + element.PGR_DESCRICAO;
                                product.state = "PR";
                                product.img = element.PRD_CAMINHO;
                                product.description = element.PRD_DESCRICAO;


                                const productDesc =
                                    product.name.trim()
                                        .replace(/\s+/g, "-")
                                        .replace(/[^a-zA-Z0-9záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ-]/g, "")
                                        .toLowerCase()
                                    + "-" +
                                    element.PRD_DESCRICAO.trim()
                                        .replace(/\s+/g, "-")
                                        .replace(/[^a-zA-Z0-9záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ-]/g, "")
                                        .toLowerCase();

                                product.url = "/loja/produto/" + product.code + "/" + productDesc;
                                product.price = element.PRECOPRODUTO;
                                product.showActions = false;
                                product.isLogged = element.IS_LOGGED;
                                product.promotionalPrice = element.PRECO_DE;
                                this.hotsite.listModel2.push(product);
                            })
                        }
                        else {
                            this.hotsite.listModel1 = campanha.Produtos;
                        }
                        this.loadnew = true;
                    }
                }
                xhr.send();
            },
            getMarca: function () {
                const self = this;
                let xhr = new XMLHttpRequest()
                let nomeMarca = self.$route.params.id.replace(/-/g, ' ');
                xhr.open("GET", this.$apiUrl + "Marketing.svc/getmarca/" + nomeMarca)
                xhr.setRequestHeader('Content-type', 'application/json')
                xhr.withCredentials = true

                xhr.onload = () => {
                    if (xhr.status == 200) {
                        this.loading = false

                        let marca = JSON.parse(xhr.responseText)
                        this.idMarca = marca.AbasCampanha[0].Id;
                        localStorage.idMarca = this.idMarca;
                        this.nome = marca.AbasCampanha[0].Nome;
                        this.title = marca.AbasCampanha[0].MetaTitle
                            ? marca.AbasCampanha[0].MetaTitle
                            : `Distribuidora Oficial ${this.nome} - Aldo Solar`
                        this.metaDescription = marca.AbasCampanha[0].MetaDescription

                        // Carregando Banners
                        marca.BannersRotativos.forEach((element) => {
                            let itemCarousel = {}
                            itemCarousel.banner = element.m_Item1
                            itemCarousel.staticLink = element.m_Item2 != '#' ? element.m_Item2 : '#'
                            itemCarousel.title = element.m_Item3;
                            itemCarousel.alt = element.m_Item4;
                            self.hotsite.slider.push(itemCarousel)
                        })
                        if (marca.BannersRotativos.length > 0) {
                            setTimeout(function () { self.startSlider() }, 400);
                        }

                        // Carregando as Abas da Campanha
                        marca.AbasCampanha.forEach((element) => {
                            if (element.ConteudoAba != null || element.Tipo === "P") {
                                let tab = {}

                                if (element.Tipo === "P" && marca.ListaProdutosMarca.length == 0)
                                    return;

                                if (element.Tipo === "P") {
                                    tab.tipo = 2;
                                    tab.filter = false;


                                    tab.ConteudoAba = marca.AbasCampanha.find(element => element.AbaNome.toUpperCase() == 'SOBRE A MARCA').ConteudoAba;
                                    this.descricao = tab.ConteudoAba
                                }
                                else if (element.ConteudoAba != null) {
                                    tab.tipo = 3;
                                    tab.ConteudoAba = element.ConteudoAba;
                                }

                                tab.titulo = element.AbaNome

                                self.hotsite.tabs.push(tab)
                            }
                            else if (element.Tipo === "E" && element.ConteudoAba == null) {
                                let tab = {}
                                tab.tipo = 3
                                tab.titulo = element.AbaNome
                                self.hotsite.conteudoEspecial = marca.ConteudoEspecial
                                self.hotsite.tabs.push(tab)
                            }
                            else if (element.Tipo === "T" && marca.Produtos.length > 0) {
                                let tab = {}

                                tab.tipo = 1
                                tab.titulo = element.AbaNome
                                tab.filter = false
                                tab.ConteudoAba = marca.AbasCampanha.find(element => element.AbaNome.toUpperCase() == 'SOBRE A MARCA').ConteudoAba;
                                this.descricao = tab.ConteudoAba
                                self.hotsite.tabs.push(tab)
                            }
                            else if (element.Tipo === 'C' && marca.AbasCampanhaMarca.length > 0) {
                                let tab = {}

                                self.hotsite.campanhaMarcas = marca.AbasCampanhaMarca

                                tab.tipo = 4
                                tab.titulo = element.AbaNome
                                self.hotsite.tabs.push(tab)
                            }
                        })
                        this.$delete(self.hotsite.tabs, self.hotsite.tabs.findIndex(element => element.titulo.toUpperCase() == 'SOBRE A MARCA'))
                        this.hotsite.listModel1 = marca.Produtos;
                        this.loadnew = true;
                    }
                }
                xhr.send();
            },
            startSlider: function () {
                var _this = $("#promotial-carousel"),
                    _owl = _this,
                    _config = _this.data(),
                    _animateOut = _this.data("animateout"),
                    _animateIn = _this.data("animatein"),
                    _slidespeed = _this.data("slidespeed");

                _config.navText = [
                    '<i class="fa fa-angle-left" aria-hidden="true"></i>',
                    '<i class="fa fa-angle-right" aria-hidden="true"></i>'
                ];
                if (typeof _animateOut != "undefined") {
                    _config.animateOut = _animateOut;
                }
                if (typeof _animateIn != "undefined") {
                    _config.animateIn = _animateIn;
                }
                if (typeof _slidespeed != "undefined") {
                    _config.smartSpeed = _slidespeed;
                }
                if ($("body").hasClass("rtl")) {
                    _config.rtl = true;
                }
                _owl.on("drag.owl.carousel", function (event) {
                    _owl.addClass("owl-changed");
                    setTimeout(function () {
                        _owl.removeClass("owl-changed");
                    }, _config.smartSpeed);
                });
                _owl.on('mouseover', function (e) {
                    var data = $(e.currentTarget).data('owl.carousel');
                    if (data.settings.autoplay) {
                        $(e.currentTarget).trigger('stop.owl.autoplay');
                    }
                });
                _owl.on('mouseleave', function (e) {
                    var data = $(e.currentTarget).data('owl.carousel');
                    if (data.settings.autoplay) {
                        _owl.trigger('play.owl.autoplay', [5000])
                    }
                });
                _owl.owlCarousel(_config);


            }
        },
        computed: {
            breadcrumbPages: function () {
                let pname = "";
                let plink = "";
                let plinkpage = "";
                let pnamepage = "";
                if (this.hotsite !== undefined) {
                    pnamepage = this.$route.path.split('/')[3].toUpperCase();
                    plinkpage = this.$SiteUrl + this.$route.path;
                    if (this.hotsite.tipo == "campanhas") {
                        pname = "Campanhas";
                        plink = this.$SiteUrl + '/loja/campanhas';
                    }
                    else {
                        pname = "Marcas";
                        plink = this.$SiteUrl + '/loja/marcas';
                    }

                }
                return [
                    { name: `Home`, link: "https://www.aldo.com.br/loja" },
                    { name: pname, link: plink },
                    { name: pnamepage, link: plinkpage },
                ];
            }
        },

        beforeMount() {
            if (this.hotsite.tipo === "campanhas") {
                this.getCampanha()
                this.tipo = 'campanha'
            }
            else {
                this.getMarca();
                this.tipo = 'marca'
            }
        },
        data() {
            return {
                loadnew: false,
                nome: '',
                title: '',
                metaDescription: '',
                loading: true,
                tipo: '',
                idCampanha: 0,
                idMarca: 0,

                hotsite: {
                    tipo: this.$route.path.split('/')[2],
                    slider: [],
                    tabs: [],
                    listModel1: [],
                    listModel2: [],
                    marcas: [],
                    conteudoEspecial: [],
                    campanhaMarcas: []
                }
            };
        }
    };
</script>
